import React from 'react'
import './Footer.css'
import './Mobile__Footer.css'
import { NavLink } from 'react-router-dom'

function Footer() {
    return (
        <div className="Footer__Container">

            <div className="Footer__widget__1">

                <div className="widget widget__1 widget__text__container">
                    <h2>Navigation</h2>
                    <ul className="naviagtion__list">
                        <li><NavLink to = "/">Home</NavLink></li>
                        <li className="margin__top"><NavLink to = "/About" >About</NavLink> </li>
                        <li className="margin__top"><NavLink to="/Projects">Projects</NavLink ></li>
                        <li className="margin__top"><NavLink to="/Skills">Skills</NavLink ></li>
                        <li className="margin__top"><NavLink to="/Contact">Contact Me</NavLink></li>
                    </ul>
                </div>

            </div>
            
            <div className="Footer__widget__2">

                <div className="widget widget__2 widget__text__container">
                    <h2> Skills </h2>
                    <p className="margin__top">
                    <span className="tag">Assembly</span> to <span className="tag">python</span> i have worked with <span className="tag">node.js</span>, <span className="tag">Html</span>, <span className="tag">Css</span>, <span className="tag">Javascript</span>, Front/Backend frameworks. as well as <span className="tag">java</span>,<span className="tag"> mysql</span>,
                        along with NOSQL database technologies <span className="tag">mangoDB</span> 
                    </p>
                </div>

            </div>

            <div className="Footer__widget__3">

                <div className="widget__3 widget__text__container">
                    <h2>Contact Me!</h2>
                    <ul className="naviagtion__list">
                        <li>Days available: <span>Monday-Friday</span></li>
                        <li>Email: <span>d.gaona1994@gmail.com</span></li>
                        <li>Phone: <span>(945)703-4247</span></li>
                    </ul>
                </div>

            </div>
        </div>
    )
}

export default Footer
